import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../../Auth/AuthContext';

// Paths where the gate is not shown so the user can still subscribe
const ALLOWED_PATHS = ['/billing', '/payments'];

const TrialExpiredGate = ({ children }) => {
  const { accountStatus } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isExpired = accountStatus === 'EXPIRED';
  const isAllowedPath = ALLOWED_PATHS.includes(location.pathname);

  return (
    <>
      {children}
      {isExpired && !isAllowedPath && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Paper
            elevation={6}
            sx={{
              maxWidth: 480,
              width: '100%',
              p: 5,
              borderRadius: 3,
              textAlign: 'center',
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: 56, color: '#d32f2f', mb: 2 }} />

            <Typography variant="h5" fontWeight="bold" mb={1}>
              Your Free Trial Has Ended
            </Typography>

            <Typography color="text.secondary" mb={3}>
              Your 15-day free trial has expired. Subscribe to a paid plan to continue using Pool Route Monitor and keep access to all your data.
            </Typography>

            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => navigate('/billing')}
              sx={{ mb: 2, backgroundColor: '#002244', '&:hover': { backgroundColor: '#003366' } }}
            >
              Subscribe Now
            </Button>

            <Typography variant="body2" color="text.secondary">
              Questions?{' '}
              <a href="mailto:support@poolroutemonitor.com" style={{ color: '#002244' }}>
                Contact support
              </a>
            </Typography>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default TrialExpiredGate;
